import React, {Component} from 'react';
import Page from '../../components/Page';
import './styles.css';

class TimeCards extends Component {
    render() {
        return (
            <Page {...this.props} >
                <div className="col-xs-12">
                    <div className="Card">
                        <div className="Empty">
                            <i className="fa fa-clock-o" />
                            <div className="t">Time cards</div>
                            <div className="s">This section is coming soon.</div>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}
export default TimeCards;



// WEBPACK FOOTER //
// ./src/screens/TimeCards/index.js